import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../services/login.service';
import {Router} from '@angular/router';
import {MenuController} from '@ionic/angular';
import {ApiService} from '../../services/api.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  readonly version = '1.0.0';
  readonly logoUrl = environment.logoUrl;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private menuCtrl: MenuController,
    private apiService: ApiService
  ) {
  }

  ngOnInit() {
  }

  _navigateTo(url: string) {
    this.menuCtrl.close().then(() => {
      this.router.navigate([url]);
    });
  }

  logout() {
    this.menuCtrl.close().then(() => {
      this.loginService.deleteAuthData().subscribe(() => {
        this._navigateTo('/login');
      });
    });
  }

  navigateToPageInDev() {
    this.router.navigate(['event/424370/all-companies-form'], {
      queryParams: {
        contactId: 1395661,
        orderId: 213959,
        calendarId: 424370
      },
    });
  }
}
